import React from "react";
import PropTypes from "prop-types";

import Header from "./Header.jsx";
import Footer from "../../components/Footer.jsx";
import DevelopmentMarker from "../../components/DevelopmentMarker.jsx";

import { fetchConfig } from "../service/config.js";

// import favicon from "../../../img/favicon.png";
import NotificationHost from "../../components/NotificationHost.jsx";
import { getTenant } from "../utils/tenant.js";

export default class App extends React.Component {
	static propTypes = {
		children: PropTypes.node,
	};

	state = {
		config: {},
	};

	componentDidMount() {
		const tenant = getTenant();

		Object.entries(tenant.colors).forEach(([key, value]) => {
			document.documentElement.style.setProperty(key, value);
		});

		fetchConfig().then((config) => this.setState({config}));
	}

	render() {
		var contentStyle = {
			"minHeight": "600px"
		};
		return (
			<div>
				<DevelopmentMarker/>
				<Header/>
				<div className="container-fluid" style={contentStyle}>
					{this.props.children}
				</div>
				<Footer config={this.state.config}/>
				<NotificationHost/>
			</div>
		);
	}
}

